import { useMemo } from 'react';
import { useAllLots, useCollectible } from 'src/features/common/collectible/hooks/collectible.hooks';
import { useActiveOwners } from 'src/features/common/collectible/hooks/use-nft-owners';
import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';
import { useMyWalletsById } from 'src/features/common/wallet/hooks/use-my-wallets-by-id';

/**
 * Available NFT's copies which user can sell.
 */
export const useAvailableCopies = () => {
    const nft = useCollectible();
    const activeOwners = useActiveOwners();
    const allLots = useAllLots();
    const { user } = useProfile() || {};
    const myWallets = useMyWalletsById();

    return useMemo<number>(() => {
        if (!user || !nft?.copies) {
            return 0;
        }
        // Current user is not an active owner
        const ownerInventory = activeOwners.items.find((owner) => myWallets[owner.address]);
        if (!ownerInventory) {
            return 0;
        }
        const copiesOnSell = allLots
            .filter((lot) => !lot.isDeleted && lot.isActive)
            .filter((lot) => myWallets[lot.owner])
            .reduce((acum, lot) => +(lot.remainCopies ?? lot.copies ?? 0) + acum, 0);

        return +ownerInventory.copies - copiesOnSell;
    }, [user, nft?.copies, activeOwners.items, allLots, myWallets]);
};
